import { ContactForm } from "./ContactForm";
function ContactMe  () {
    return(
        <div style={{placeItems: "center",verticalAlign:'middle',}}>
            <ContactForm/>
        </div>
    );
}

export default ContactMe;